var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settingLoaded)?_c('page-list',{ref:"EXTERNAL",attrs:{"list":_vm.list,"columns":_vm.columns,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions,"group-actions":_vm.groupActions,"editConfig":{trigger: 'click', mode: 'cell', showIcon: false, showStatus: true},"dataMapper":_vm.listDataMapper}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }